import DSV from "./Project photos/DataStructure4.png"
import movie from "./Project photos/Movie recommender11.png"
import cars from "./Project photos/cars4.jpg"
import review from "./Project photos/review5.jpg"
import green from "./Project photos/green fashion2.jpg"
import maze from "./Project photos/maze2.jpg"
import c4_project from "./Project photos/c42.png"
import visionMaster from "./Project photos/VisionMaster.jpg"
import englishify from "./Project photos/Englishify.jpg"
import prediction from "./Project photos/prediction.jpg"
import spots from "./Project photos/spots.jpg"
import server from "./Project photos/server.jpg"
import scheduler from "./Project photos/scheduler.jpg"

export const projectsData = [
  {
    id: 11,
    title: "YU Classroom Finder",
    image: spots,
    description: "Collaborated with a team to engineer a high-traffic web application enabling York University students to locate available study spaces. Successfully deployed to a user base of over 5,000 students, utilizing a modern tech stack for optimal performance and scalability.",
    tools: ["React", "Next.js", "TypeScript", "TailwindCSS", "Python", "MySQL", "Docker", "AWS EC2"],
    jobTags: ["Full Stack", "SWE", "Web Development"],
    links: {
      github: "https://github.com/AndrewidRizk/StudySpots",
      live: "https://spots.yorku.dev/",
    },
  },

  {
    id: 1,
    title: "Data Structure Visualizer",
    image: DSV,
    description: "Designed and implemented an interactive educational platform using Flask and D3.js, allowing users to visualize and manipulate complex data structures like Binary Search Trees and Heaps in an engaging, arcade-style environment.",
    tools: ["Python", "Flask", "HTML5", "CSS", "D3.js"],
    jobTags: ["SWE", "Full Stack"],
    links: {
      github: "https://github.com/AndrewidRizk/DataStructureVisualizer",
      live: "https://data-structure-visualizer-lac.vercel.app/",
    },
  },
  {
    id: 8,
    title: "VisionMaster",
    image: visionMaster,
    description: "Developed a custom object detection model using Faster R-CNN on the COCO dataset. Optimized the model to accurately classify and localize objects in challenging conditions, such as occlusion and low lighting.",
    tools: ["Python", "Flask", "PyTorch", "TorchVision"],
    jobTags: ["ML", "AI", "Computer Vision"],
    links: {
      github: "https://github.com/AndrewidRizk/Object-Detection-ML",
      live: "https://visionmaster.duckdns.org/",
    },
  },
  {
    id: 9,
    title: "Englishify",
    image: englishify,
    description: "Built a comprehensive educational web application helping second-language learners master English. Features include real-world usage examples from YouTube and native pronunciation guides, powered by a React frontend and PostgreSQL backend.",
    tools: ["Python", "Flask", "React.js", "PostgreSQL"],
    jobTags: ["SWE", "Full Stack"],
    links: {
      github: "https://github.com/AndrewidRizk/Englishify-public",
      live: "https://englishify.vercel.app/",
    },
  },
  {
    id: 10,
    title: "Toronto House Price Predictor",
    image: prediction,
    description: "Engineered a predictive analytics web app using a Random Forest model to estimate real estate prices in Toronto. Analyzes trends across neighborhoods and property types to provide actionable data-driven insights.",
    tools: ["Python", "Flask", "Pandas", "Scikit-learn", "React"],
    jobTags: ["ML", "Data Science", "Full Stack"],
    links: {
      github: "https://github.com/AndrewidRizk/Toronto-House-Prices-Predection-App",
      live: "https://toronto-house-prices-predection-app-95qo.vercel.app/",
    },
  },
    {
    id: 12,
    title: "Home Server Environment",
    image: server,
    description: "Transformed legacy hardware into robust Linux servers, optimizing resource allocation and network configuration. Implemented secure API endpoints, database hosting, and automated CI/CD pipelines, fully encrypted via SSL/TLS for production-grade security.",
    tools: ["UNIX/Linux", "Shell Scripting", "AWS Lambda", "Jenkins", "SSL/TLS"],
    jobTags: ["DevOps", "Cloud", "System Administration"],
    links: {
    },
  },
  {
    id: 13,
    title: "Kernel Scheduler",
    image: scheduler,
    description: "Architected an operating system-level job scheduler in C, simulating core kernel functions. Implemented and analyzed multiple CPU scheduling algorithms—including Shortest Job First (SJF), Earliest Deadline First (EDF), and Round Robin—to optimize process execution and resource management.",
    tools: ["C"],
    jobTags: ["Systems", "OS", "Algorithms"],
    links: {
      github: "https://github.com/AndrewidRizk/Kernel-Scheduler",
    },
  },
  {
    id: 2,
    title: "Movie Recommender",
    image: movie,
    description: "Developed a secure, personalized movie recommendation engine. Features user authentication, watchlist management, and integration with TMDB and YouTube APIs, backed by a robust MySQL database.",
    tools: ["Python", "Flask", "MySQL", "HTML5", "CSS"],
    jobTags: ["SWE", "Full Stack"],
    links: {
      github: "https://github.com/AndrewidRizk/Movie-Recommender",
      live: "https://movie-recommender-bice.vercel.app//",
    },
  },
  {
    id: 4,
    title: "Reviewify",
    image: review,
    description: "Collaborated on an AI-powered web app that analyzes Google Reviews using Cohere’s NLP APIs. Engineered a Redis database and integrated Google Geolocation APIs to deliver sentiment analysis and insights for businesses.",
    tools: ["Python", "Flask", "React.js", "Tailwind CSS"],
    jobTags: ["SWE", "Full Stack", "AI"],
    links: {
      github: "https://github.com/AndrewidRizk/Reviewify-Business",
      live: "https://reviewify-frontend.vercel.app/",
    },
  },
  {
    id: 3,
    title: "AbouelNile Motors",
    image: cars,
    description: "Delivered a complete dealership website for AbouelNile Motors, managing the full SDLC. Implemented features for vehicle listings, service pricing, photo galleries, and an online booking system for customer convenience.",
    tools: ["HTML5", "CSS", "JavaScript"],
    jobTags: ["Web Development", "SWE"],
    links: {
      github: "https://github.com/AndrewidRizk/AbouelNileMotors",
      live: "https://andrewidrizk.github.io/AbouelNileMotors/",
    },
  },
  {
    id: 6,
    title: "Green Style",
    image: green,
    description: "Award-winning sustainability project promoting environmental awareness. Led the development of a user-friendly educational website, collaborating with a diverse team to drive engagement and eco-friendly initiatives.",
    tools: ["Wix", "HTML5", "CSS", "JavaScript"],
    jobTags: ["Web Development"],
    links: {
      github: "https://github.com/AndrewidRizk/GreenStyle",
      live: "https://drdav91.wixsite.com/mysite",
    },
  },
  {
    id: 7,
    title: "Maze Generator",
    image: maze,
    description: "Created a Java-based algorithm to generate and solve complex mazes. Built an API that produces customizable mazes and calculates optimal paths using depth-first search and 2D array manipulation.",
    tools: ["Java", "HTML5", "CSS", "JavaScript"],
    jobTags: ["SWE", "Algorithms"],
    links: {
      github: "https://github.com/AndrewidRizk/A-Maze-Generator-and-visualizer",
      live: "https://a-maze-generator-and-visualizer.vercel.app/",
    },
  },
];
